var $0b73a22f92f43e6f$exports = {};
$0b73a22f92f43e6f$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$0b73a22f92f43e6f$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
